/**
 * A page's lifetime, for async work that may finish after the user has
 * already navigated away. Check `isDisposed()` after every await before
 * touching the DOM.
 *
 * A method rather than a boolean field on purpose: TypeScript narrows a
 * field after the first check and would treat later checks (after an
 * await) as always false.
 */
export interface Lifetime {
  isDisposed(): boolean;
  dispose(): void;
}

export function createLifetime(): Lifetime {
  let disposed = false;
  return {
    isDisposed: () => disposed,
    dispose: () => {
      disposed = true;
    },
  };
}
